const { fetchJSON } = window.BAO.Utils

class HarperCta extends window.BAO.CustomElement() {
  
  async connectedCallback () {
    super.connectedCallback()

    this.showCta()
  }

  setupListeners () {
    super.setupListeners()
    console.log('HarperCta setupListeners');
    if (this.els?.trigger?.exists) {
      this.els.trigger.elements.forEach(el => {
        el.addEventListener('click', this.onClick.bind(this))
      })
    }
  }

  showCta () {
    this.setAttribute('aria-hidden', 'false')

    if (this.externalEls?.message?.exists) {
      this.externalEls.message.elements.forEach(el => {
        el.setAttribute('aria-hidden', 'true')
      })
    }
  }

  onClick () {
    if (document.querySelector('[data-product-add-to-cart]')) {
      document.querySelector('[data-product-add-to-cart]').click()
    }
  }

  get sessionStorageName () {
    return 'bao-user-city'
  }
}

if (!customElements.get('harper-cta')) {
  customElements.define('harper-cta', HarperCta)
}
